import { Expose, Type } from "class-transformer";
import { IsArray, IsBoolean, IsDateString, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import GenericTableResponse from "../../GenericTableResponse";

export class StandingOrder {
  @Expose()
  @IsString()
  id!: string;

  @Expose()
  @IsString()
  orderId!: string;

  @Expose()
  @IsNumber()
  recordStampId!: number;

  @Expose()
  @IsString()
  name!: string;

  @Expose()
  @IsDateString()
  enabledDateFrom!: string;

  @Expose()
  @IsOptional()
  @IsDateString()
  enabledDateTo!: string | null;

  @Expose()
  @IsDateString()
  nextRunAt!: string;

  @Expose()
  @IsOptional()
  @IsDateString()
  lastRunAt!: string | null;

  @Expose()
  @IsBoolean()
  isEnabled!: boolean;

  @Expose()
  @IsNumber()
  type!: number;

  @Expose()
  @IsArray()
  days: Array<number> = [];

  @Expose()
  @IsArray()
  notificationEmails: Array<string> = [];

  @Expose()
  @IsBoolean()
  isDeleted!: boolean;
}

export class StandingOrderTableResponse extends GenericTableResponse<StandingOrder> {
  @Expose()
  @IsArray()
  @Type(() => StandingOrder)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<StandingOrder>;
}

export class StandingOrderItem {
  @Expose()
  @IsString()
  id!: string;

  @Expose()
  @IsString()
  standingOrderId!: string;

  @Expose()
  @IsString()
  orderId!: string;

  @Expose()
  @IsNumber()
  recordStampId!: number;

  @Expose()
  @IsDateString()
  creationDate!: string;

  @Expose()
  @IsBoolean()
  isDeleted!: string;

  @Expose()
  @IsArray()
  documentNumbers!: Array<string>;
}

export class StandingOrderItemTableResponse extends GenericTableResponse<StandingOrderItem> {
  @Expose()
  @IsArray()
  @Type(() => StandingOrderItem)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<StandingOrderItem>;
}
